import { render, staticRenderFns } from "./RelatorioAcoesUsuarios.vue?vue&type=template&id=6f0a7fee&scoped=true"
import script from "./RelatorioAcoesUsuarios.vue?vue&type=script&lang=js"
export * from "./RelatorioAcoesUsuarios.vue?vue&type=script&lang=js"
import style0 from "./RelatorioAcoesUsuarios.vue?vue&type=style&index=0&id=6f0a7fee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0a7fee",
  null
  
)

export default component.exports